<template lang="pug">
b-container.mt-2.mt-md-4.pr-2.pr-md-4.pl-2.pl-md-4(fluid="xl")
  b-row.align-items-center.pb-4.pb-md-0(v-if="isDashboard")
    b-col.mb-2.mb-md-4(cols="12")
      .d-flex.p-2.p-md-3.pl-3.flex-column.justify-content-center.align-items-center.transit-card
        .d-flex.justify-content-between.align-items-center.w-100
          h3.m-0(style="color: #a43246;") {{ $t($router.currentRoute.query.id ? 'navbar.transitsDetails' : 'navbar.transitsList') }}
          //- b-button(id="tooltip-target-b") {{ $t('addTransit.title') }}

          b-button.add-button( v-b-tooltip.hover.left :title="$t('addTransit.title')"  v-if="transits && (transits.length>0 || filterList!='all' || loade)" variant="secondary" pill @click="$router.push({name: 'clientAddTransit'})" )
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="35" height="35" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M85.83203,17.04323c-6.32845,0.09274 -11.38527,5.2949 -11.2987,11.62344v45.86667h-45.86667c-4.13529,-0.05848 -7.98173,2.11417 -10.06645,5.68601c-2.08471,3.57184 -2.08471,7.98948 0,11.56132c2.08471,3.57184 5.93115,5.74449 10.06645,5.68601h45.86667v45.86667c-0.05848,4.13529 2.11417,7.98173 5.68601,10.06645c3.57184,2.08471 7.98948,2.08471 11.56132,0c3.57184,-2.08471 5.74449,-5.93115 5.68601,-10.06645v-45.86667h45.86667c4.13529,0.05848 7.98173,-2.11417 10.06645,-5.68601c2.08471,-3.57184 2.08471,-7.98948 0,-11.56132c-2.08471,-3.57184 -5.93115,-5.74449 -10.06645,-5.68601h-45.86667v-45.86667c0.04237,-3.09747 -1.17017,-6.08033 -3.36168,-8.26973c-2.1915,-2.18939 -5.17553,-3.39907 -8.27296,-3.35371z"></path></g></g></svg>
            //- | {{ $t('addTransit.title') }}
          .d-flex.filter-button(@click="showFilters=!showFilters" v-if="!$router.currentRoute.query.id") 
            span {{ $t('addTransit.filter') }}
            <svg class="sort-t-ico-1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M35.83333,14.33333l21.5,21.5l21.5,-21.5zM107.5,14.33333l-21.5,21.5h43zM21.5,50.16667v14.33333h7.16667l43,55.27572v37.89095h28.66667v-37.89095l43,-55.27572h7.16667v-14.33333z"></path></g></g></svg>
            //- <svg class="sort-t-ico-1" v-if="showFilters" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18" height="18" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M86,157.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667c0,39.5815 32.08517,71.66667 71.66667,71.66667zM86,78.83333l-35.83333,28.66667v-21.5l35.83333,-28.66667l35.83333,28.66667v21.5z"></path></g></g></svg>
        TransitionExpand
          div(v-if="showFilters")
            .sort-t-container.d-flex.flex-md-nowrap.flex-wrap.justify-content-center.mt-1
              b-button.btn.sort-t-button(:class="{'sort-t-button-selected' : filterList=='all', 'sort-t-button-disabled' : loade }" @click="filterData('all')" :disabled="loade") 
                <svg class="sort-t-ico-2" v-if="filterList=='all'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style="fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M143.33333,107.5l-57.33333,-57.33333l-57.33333,57.33333z"></path></g></g></svg>
                span {{ $t('addTransit.fAll') }}
              b-button.btn.sort-t-button(:class="{'sort-t-button-selected' : filterList=='draft', 'sort-t-button-disabled' : loade }" @click="filterData('draft')" :disabled="loade") 
                <svg class="sort-t-ico-2" v-if="filterList=='draft'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style="fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M143.33333,107.5l-57.33333,-57.33333l-57.33333,57.33333z"></path></g></g></svg>
                span {{ $t('addTransit.fDraft') }}
              b-button.btn.sort-t-button(:class="{'sort-t-button-selected' : filterList=='waitOffer', 'sort-t-button-disabled' : loade }" @click="filterData('waitOffer')" :disabled="loade") 
                <svg class="sort-t-ico-2" v-if="filterList=='waitOffer'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style="fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M143.33333,107.5l-57.33333,-57.33333l-57.33333,57.33333z"></path></g></g></svg>
                span {{ $t('addTransit.fWait') }}
              b-button.btn.sort-t-button(:class="{'sort-t-button-selected' : filterList=='foundOffer', 'sort-t-button-disabled' : loade }" @click="filterData('foundOffer')" :disabled="loade") 
                <svg class="sort-t-ico-2" v-if="filterList=='foundOffer'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style="fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M143.33333,107.5l-57.33333,-57.33333l-57.33333,57.33333z"></path></g></g></svg>
                span {{ $t('addTransit.fFound') }}
              b-button.btn.sort-t-button(:class="{'sort-t-button-selected' : filterList=='pendingPay', 'sort-t-button-disabled' : loade }" @click="filterData('pendingPay')" :disabled="loade") 
                <svg class="sort-t-ico-2" v-if="filterList=='pendingPay'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style="fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M143.33333,107.5l-57.33333,-57.33333l-57.33333,57.33333z"></path></g></g></svg>
                span {{ $t('addTransit.fWaitPayement') }}
              b-button.btn.sort-t-button(:class="{'sort-t-button-selected' : filterList=='transit', 'sort-t-button-disabled' : loade }" @click="filterData('transit')" :disabled="loade") 
                <svg class="sort-t-ico-2" v-if="filterList=='transit'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style="fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M143.33333,107.5l-57.33333,-57.33333l-57.33333,57.33333z"></path></g></g></svg>
                span {{ $t('addTransit.fTransit') }}
              b-button.btn.sort-t-button(:class="{'sort-t-button-selected' : filterList=='done', 'sort-t-button-disabled' : loade }" @click="filterData('done')" :disabled="loade") 
                <svg class="sort-t-ico-2" v-if="filterList=='done'" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14" height="14" viewBox="0 0 172 172" style="fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M143.33333,107.5l-57.33333,-57.33333l-57.33333,57.33333z"></path></g></g></svg>
                span {{ $t('addTransit.fDone') }}
    b-col.pb-2.pb-md-4(cols="12" v-if="!loadeErr && !init && (!transits || transits.length==0)")
      div.new-transit
        <svg xmlns="http://www.w3.org/2000/svg" v-if="!$router.currentRoute.query.id && filterList=='all'" class="icon-tv" x="0px" y="0px" width="77" height="77" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#343a40"><path d="M143.33333,132.58333v10.75h-114.66667v-10.75c-5.93758,0 -10.75,4.81242 -10.75,10.75c0,5.93758 4.81242,10.75 10.75,10.75c1.96725,0 112.69942,0 114.66667,0c5.93758,0 10.75,-4.81242 10.75,-10.75c0,-5.93758 -4.81242,-10.75 -10.75,-10.75zM143.33333,23.29167c0,-1.98158 -1.09292,-3.8055 -2.838,-4.74075c-1.74867,-0.93525 -3.87,-0.83133 -5.51833,0.26875l-13.29417,8.86517l-14.99983,-9.00133c-1.70567,-1.02125 -3.83058,-1.02125 -5.52908,0l-15.15392,9.08733l-15.15392,-9.08733c-1.70208,-1.02125 -3.827,-1.02125 -5.52908,0l-14.99983,9.00133l-13.29417,-8.86517c-1.64833,-1.10008 -3.76608,-1.20042 -5.51833,-0.26875c-1.74508,0.93525 -2.838,2.75917 -2.838,4.74075v109.29167h114.66667zM80.625,118.25h-25.08333c-2.97058,0 -5.375,-2.40442 -5.375,-5.375c0,-2.97058 2.40442,-5.375 5.375,-5.375h25.08333c2.97058,0 5.375,2.40442 5.375,5.375c0,2.97058 -2.40442,5.375 -5.375,5.375zM87.79167,96.75h-32.25c-2.97058,0 -5.375,-2.40442 -5.375,-5.375c0,-2.97058 2.40442,-5.375 5.375,-5.375h32.25c2.97058,0 5.375,2.40442 5.375,5.375c0,2.97058 -2.40442,5.375 -5.375,5.375zM116.45833,118.25h-7.16667c-2.97058,0 -5.375,-2.40442 -5.375,-5.375c0,-2.97058 2.40442,-5.375 5.375,-5.375h7.16667c2.97058,0 5.375,2.40442 5.375,5.375c0,2.97058 -2.40442,5.375 -5.375,5.375zM116.45833,96.75h-7.16667c-2.97058,0 -5.375,-2.40442 -5.375,-5.375c0,-2.97058 2.40442,-5.375 5.375,-5.375h7.16667c2.97058,0 5.375,2.40442 5.375,5.375c0,2.97058 -2.40442,5.375 -5.375,5.375zM116.45833,68.08333h-60.91667c-2.97058,0 -5.375,-2.40442 -5.375,-5.375c0,-2.97058 2.40442,-5.375 5.375,-5.375h60.91667c2.97058,0 5.375,2.40442 5.375,5.375c0,2.97058 -2.40442,5.375 -5.375,5.375z"></path></g></g></svg>
        <svg xmlns="http://www.w3.org/2000/svg" v-if="$router.currentRoute.query.id" class="icon-tv" x="0px" y="0px" width="77" height="77" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#343a40"><path d="M71.66667,14.33333c-31.57944,0 -57.33333,25.75389 -57.33333,57.33333c0,31.57944 25.75389,57.33333 57.33333,57.33333c14.50482,0 27.74719,-5.46789 37.86295,-14.40332l5.13705,5.13705v9.26628l28.66667,28.66667l14.33333,-14.33333l-28.66667,-28.66667h-9.26628l-5.13705,-5.13705c8.93544,-10.11576 14.40332,-23.35813 14.40332,-37.86295c0,-31.57944 -25.7539,-57.33333 -57.33333,-57.33333zM71.66667,28.66667c23.83313,0 43,19.16687 43,43c0,23.83313 -19.16687,43 -43,43c-23.83313,0 -43,-19.16687 -43,-43c0,-23.83313 19.16687,-43 43,-43zM50.16667,57.33333c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM93.16667,57.33333c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM71.66667,78.80534c-8.76187,0 -17.52898,2.64054 -24.94336,7.93652l8.32845,11.67383c9.75291,-6.96637 23.46291,-6.96637 33.21582,0l8.32846,-11.67383c-7.41438,-5.29599 -16.16749,-7.93652 -24.92936,-7.93652z"></path></g></g></svg>
        <svg xmlns="http://www.w3.org/2000/svg" v-if="!$router.currentRoute.query.id && filterList!='all'" class="icon-tv" x="0px" y="0px" width="77" height="77" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#343a40"><path d="M71.66667,14.33333c-31.57944,0 -57.33333,25.75389 -57.33333,57.33333c0,31.57944 25.75389,57.33333 57.33333,57.33333c14.50482,0 27.74719,-5.46789 37.86295,-14.40332l5.13705,5.13705v9.26628l28.66667,28.66667l14.33333,-14.33333l-28.66667,-28.66667h-9.26628l-5.13705,-5.13705c8.93544,-10.11576 14.40332,-23.35813 14.40332,-37.86295c0,-31.57944 -25.7539,-57.33333 -57.33333,-57.33333zM71.66667,28.66667c23.83313,0 43,19.16687 43,43c0,23.83313 -19.16687,43 -43,43c-23.83313,0 -43,-19.16687 -43,-43c0,-23.83313 19.16687,-43 43,-43zM50.16667,57.33333c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM93.16667,57.33333c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM71.66667,78.80534c-8.76187,0 -17.52898,2.64054 -24.94336,7.93652l8.32845,11.67383c9.75291,-6.96637 23.46291,-6.96637 33.21582,0l8.32846,-11.67383c-7.41438,-5.29599 -16.16749,-7.93652 -24.92936,-7.93652z"></path></g></g></svg>
        span.new-text-title {{ $t(`addTransit.${$router.currentRoute.query.id ?'notFound' : filterList=='all' ? 'newTitle' : 'filterEmptyTitle'}`) }}
        span.new-text(v-if="!$router.currentRoute.query.id") {{ $t(`addTransit.${filterList=='all' ? 'new' : 'filterEmpty'}`) }}
        b-button.add-new-button(v-if="!$router.currentRoute.query.id && filterList=='all'" variant="secondary" pill @click="$router.push({name: 'clientAddTransit'})")
          <i class="fa fa-plus mr-3"></i>
          | {{ $t('addTransit.title') }}
        b-button.reload-button(v-if="!$router.currentRoute.query.id && filterList!='all'" variant="secondary" pill @click="filterData('all')" ) {{ $t('addTransit.showAllData') }}
    b-col.pb-2.pb-md-4(cols="12" v-if="init && !loadeErr" v-for="index in 3" :key="index")
      TransitLoading
    b-col.pb-2.pb-md-4(cols="12" v-if="loadeErr && (!transits || transits.length==0)")
      .new-transit(style="border-color: #a432464a")
        <svg xmlns="http://www.w3.org/2000/svg" class="icon-tv" x="0px" y="0px" width="77" height="77" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M71.66667,14.33333c-31.57944,0 -57.33333,25.75389 -57.33333,57.33333c0,31.57944 25.75389,57.33333 57.33333,57.33333c14.50482,0 27.74719,-5.46789 37.86295,-14.40332l5.13705,5.13705v9.26628l28.66667,28.66667l14.33333,-14.33333l-28.66667,-28.66667h-9.26628l-5.13705,-5.13705c8.93544,-10.11576 14.40332,-23.35813 14.40332,-37.86295c0,-31.57944 -25.7539,-57.33333 -57.33333,-57.33333zM71.66667,28.66667c23.83313,0 43,19.16687 43,43c0,23.83313 -19.16687,43 -43,43c-23.83313,0 -43,-19.16687 -43,-43c0,-23.83313 19.16687,-43 43,-43zM50.16667,57.33333c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM93.16667,57.33333c-3.95804,0 -7.16667,3.20863 -7.16667,7.16667c0,3.95804 3.20863,7.16667 7.16667,7.16667c3.95804,0 7.16667,-3.20863 7.16667,-7.16667c0,-3.95804 -3.20863,-7.16667 -7.16667,-7.16667zM71.66667,78.80534c-8.76187,0 -17.52898,2.64054 -24.94336,7.93652l8.32845,11.67383c9.75291,-6.96637 23.46291,-6.96637 33.21582,0l8.32846,-11.67383c-7.41438,-5.29599 -16.16749,-7.93652 -24.92936,-7.93652z"></path></g></g></svg>
        span.new-text-title( style="color: #a43246 !important") {{ $t('addTransit.loadError') }}
        span.new-text.mt-2( style="color: #cf97a1 !important;max-width: 350px;") {{ $t('addTransit.loadErrMsg') }}
        b-button.reload-button.mt-3(@click="getData(false)") {{$t('addTransit.reloadData')}}
    b-col.pb-2.pb-md-4(cols="12" v-for="transit in transits" :key="transit.id")
      TransitN(:transit="transit")
    div.loader-container( v-if="loade && !init && !$router.currentRoute.query.id")
      .lds-ellipsis
        div
        div
        div
        div
    .d-flex.flex-column.w-100.align-items-center( v-if="loadeErr && transits && transits.length>=1 && !$router.currentRoute.query.id" @click="getData(true)")
      b-button.load-more-button {{$t('addTransit.loadData')}}
    div.loaded-text.pt-2.pt-md-2(v-if="!loadeErr && pagend  && transits && transits.length>0 && !$router.currentRoute.query.id")
      span {{ $t('addTransit.noMoreData') }}
    .d-flex.w-100.mt-4.justify-content-center(v-if="$router.currentRoute.query && $router.currentRoute.query.id")
      b-button.show-all(@click="showAll") {{ $t('addTransit.showAllData') }}
  b-row(v-else)
    router-view
</template>

<script>
import { mapState } from 'vuex'
import TransitLoading from "@/components/ui/TransitLoading";
import TransitN from './TransitN'
import TransitionExpand from '@/components/ui/TransitionExpand'

export default {
  name: 'ClientDashboard',
  components: { TransitLoading, TransitN, TransitionExpand },
  data() {
    return {
      // transits : [],
      showFilters : false,
      filterList : 'all',
      waitScroll : false,
      pages:{
        nbPages : 1,
        cuerentPage : 1,
        pageSize: 8,
        pageData : []
      },
    }
  },
  computed: {
    ...mapState(['transits', 'loade', 'init', 'loadeErr', 'pagend', 'transitById']),
    isDashboard () {
      return this.$route.name === 'clientDashboard'
    }
  },
  watch:{
    $route (to,from){
      if (this.$route.name == "clientDashboard") {
        this.getData(false);
      }
    }
  },
  beforeMount() {
    console.log('beforeMount');
    this.getData(false);
  },
  mounted() {
    console.log('mounted');
    this.scrollHandler();
  },
  methods: {
    filterData(e){
      if(e != this.filterList){
        this.filterList = e;
        this.getData(false);
      }
    },
    showAll(){
      // this.$router.currentRoute.query={};
      this.$router.replace({ name: "clientDashboard", params: {}, query: {} })
      this.filterData('all');
      window.scrollTo(0,0);
    },
    getData(newT){
      if(!newT && !this.loadeErr){
        this.pages.cuerentPage = 1;
      }
      if(newT && !this.loadeErr){
        this.pages.cuerentPage++;
      }
      this.$store.dispatch('fetchClientTransit', {page: this.pages.cuerentPage , pageSize: this.pages.pageSize, add: newT, filter: this.filterList } )
    },
    scrollHandler(){
      window.onscroll = () => {
        if(this.$route.name == "clientDashboard" && !this.waitScroll){
          let bottomOfWindow = !this.pagend && !this.loade && !this.$router.currentRoute.query.id && document.documentElement.scrollTop + window.innerHeight >= (document.documentElement.scrollHeight - 100);
          if (bottomOfWindow) {
            this.getData(true);  
            this.waitScroll = true;
            setTimeout(() => {
              this.waitScroll = false;
            }, 1000);
          }
        };
      }
    }
  },
}
</script>

<style>
  .new-transit{
    min-height: 210px;
    border: 2px solid #989a9d47;
    border-style: dashed;
    border-radius: 10px;
    background-color: #ffffff85;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1px 21px 0 rgb(135 140 157 / 5%) !important;
    padding: 40px 10px;
  }
  .new-text-title{
    font-size: 18px;
    font-weight: 600;
    margin-top: 5px;
    margin-bottom: 5px;
    opacity: 0.4;
    color: #343a40;   
  }
  .new-text{
    font-size: 13px;
    color: #888a8c;
    margin-bottom: 20px;
    text-align: center;
  }
  .icon-tv{
    opacity: 0.3;
  }
  .add-new-button{
    border-radius: 5px !important;
    padding: 10px 45px;
    font-weight: 600;
  }
  .loading-wrapper {
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bar {
    display: block;
    height: 30px;
    width: 10px;
    background-color: #14171914;
    margin: 4px;
    animation: scale 1.6s ease-in-out infinite;
    transform-origin: 50% 50%;
  }

  .bar.one {
    animation-delay: 1s;
  }

  .bar.two {
    animation-delay: 1.2s;
  }

  .bar.three {
    animation-delay: 1.3s;
  }

  @keyframes scale {

    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.5);
    }

    100% {
      transform: scale(1);
    }
  }

  .loaded-text{
    width: 100%;
    text-align: center;
    color: #1d212485;
  }

  .add-button{
    border-radius: 32px !important;
    position: fixed;
    bottom: 25px;
    right: 20px;
    width: 60px;
    height: 60px;
    z-index: 11;
    box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%);
    padding: 0;
  }

  .sort-t-container{
    gap: 5px;
  }

  .filter-button{
    font-size: 14px;
    font-weight: 600;
    gap: 1px;
    color: #a43246;
    cursor: pointer;
  }

  .sort-t-ico-2{
    transform: rotate(90deg);
    margin-right: 1px;
    margin-left: -5px;
    margin-top: -1px;
  }

  .sort-t-ico-1{

  }

  .sort-t-button{
    background-color: white !important;
    border-color: #a432463b !important;
    color: #a43246 !important;
    border-radius: 50px;
    font-weight: 600;
    transition: all 0.2s;
  }

  .sort-t-button-selected{
    color: white !important;
    background-color: #a43246 !important;
  }

  .sort-t-button-disabled{
    opacity: 0.6;
  }

  .show-all{
    padding: 10px 10%;
    background-color: #ffffff;
    color: #a43246;
    font-weight: 600;
    border-color: #a4324647;
    border-radius: 5px;
  }
  .show-all:hover{
    background-color:#fff3f3 !important;
    color: #a43246 !important;
    border-color: #a43246;
  }

  .reload-button{
    font-size: 14px !important;
    font-weight: 600 !important;
    padding: 9px 25px !important;
    border-radius: 5px !important;
    background-color: #a43246 !important;
    color: #ffffff !important;
    border-color: #f5f7f900 !important;
  }





</style>